// jQuery
import './plugins/jquery-global.js';

// Magnific popup
import './plugins/jquery.magnific-popup';

// Masked input
import './plugins/jquery.maskedinput.min';

// Slick slider
import './plugins/slick';

// Select2
// require('./plugins/select2.full')($);

// mCustomScrollbar
// FIRST: INSTALL VIA `npm i malihu-custom-scrollbar-plugin` and then uncomment:
// require('malihu-custom-scrollbar-plugin')($);

// FancyBox
require('./plugins/fancyBox.js');

// Cookie
require('./plugins/jquery.cookie.js');

// Scripts
require('./scripts/scripts.js');
